import type { FaireProductEntity } from "../../entity_types/product";

export const p_54gbz54rw3: FaireProductEntity = {
  token: "p_54gbz54rw3",
  type: "product",
  name: 'Sm Cupping Hands Planter-5.5" W',
  brandToken: "b_a8n58zvndo",
  brandName: "Abbott",
  imageUrl:
    "https://cdn.faire.com/fastly/dbce2b8e554c682d5c90654896726b27dc4d999f82c3455f85a45b96319c4b3b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5814861308a4ed765484d54d81c241668ac416f15293d64460edf61692558d01.jpeg",
    "https://cdn.faire.com/fastly/040515eeb6664e3abcdc724f7303a40d6b2fedc7554cdf13f0b810cef555b92b.jpeg",
    "https://cdn.faire.com/fastly/9a536a71c175de2b8aa2a9f9fcf64c666dd05af899ea86097e0cb712355c135c.jpeg",
  ],
  priceDollars: 9,
  description:
    "Hands don't just help you garden; now they can also give your favourite plant a new home with this Small Cupped Hands Planter. Crafted of out cement, this planter made up of two cupped hands makes a unique decorative addition to any home or office. Raised hands planter also available.",
  tags: [],
  msrpDollars: 18,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T19:58:17.499Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
